import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    SelectInput,
    required,
    NumberInput,
} from 'react-admin';

import { Programs } from '../../custom';
import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';
import { AMBITION_LMS_ID, CLASSES, EXAMS, LANGUAGES, STATUSES } from '../../common/constants';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import SlugInput from '../../common/inputs/SlugInput';
import { LocationsAutoComplete } from '../../common/inputs/autoCompleteInputs/LocationsAutoComplete';

const ProgramEdit = () => {
    const { isUpdatable } = useIsPermission('PROGRAM');
    const user = JSON.parse(localStorage.getItem('user') as string);
    const isAmbitionLms = user?.organization_id === AMBITION_LMS_ID;
    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit title={<ProgramTitle />} mutationMode={'pessimistic'}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload type="VIDEO_THUMBNAIL" source="image" />
                    <TextInput source="name" fullWidth validate={[required()]} />
                    <SlugInput source="slug" fullWidth />
                    <NumberInput
                        type={'number'}
                        source="displayOrder"
                        fullWidth
                        validate={[required()]}
                    />
                    <SelectInput
                        source="status"
                        label={'Status'}
                        fullWidth
                        validate={[required()]}
                        choices={STATUSES}
                    />
                    <SelectInput
                        source="config.class"
                        label={'Class'}
                        fullWidth
                        validate={[required()]}
                        choices={CLASSES}
                    />
                    <SelectInput
                        source="config.language"
                        label={'Language'}
                        validate={[required()]}
                        fullWidth
                        choices={LANGUAGES}
                    />
                    <SelectInput
                        source="config.exam"
                        validate={[required()]}
                        label={'Exam'}
                        fullWidth
                        choices={EXAMS}
                    />
                    {isAmbitionLms && (
                        <LocationsAutoComplete source="location" label={'Location'} />
                    )}

                    <HTMLEditorInput
                        source={'description'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    );
};

const ProgramTitle = () => {
    const record = useRecordContext<Programs>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.programs.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default ProgramEdit;
